export var NAME = 'application';
export var APPLICATION_LOADED = "".concat(NAME, "/APPLICATION_LOADED");
export var CONFIGURATION_LOADED = "".concat(NAME, "/CONFIGURATION_LOADED");
export var MESSAGE_DISMISSED = "".concat(NAME, "/MESSAGE_DISMISSED");
export var HEADING_UPDATED = "".concat(NAME, "/HEADING_UPDATED");
export var MESSAGE_ADDED = "".concat(NAME, "/MESSAGE_ADDED");
export var TRANSLATIONS_UPDATED = "".concat(NAME, "/TRANSLATIONS_UPDATED");
export var TRANSLATION_UPDATE_REQUESTED = "".concat(NAME, "/TRANSLATION_UPDATE_REQUESTED");